skrilla.controller('recoverEventsModalCtrl', function ($scope, searchService, modalService, cacheService, queryService, bettingReferenceService) {
    $scope.eventTypes =  bettingReferenceService.eventTypes().reduce((a, v) => ({ ...a, [v]: false}), {});
    $scope.query = {
        marketStatuses: {
            SUSPENDED: false,
            DEACTIVATED: true,
            UNAVAILABLE: false,
            ACTIVE: true,
            HANDED_OVER: false,
            SETTLED: false,
            CANCELLED: false,
        },
        eventTypes: $scope.eventTypes,
        startTime: new Date(new Date().getTime() - (7 * 3600 * 24 * 1000)),
        endTime: new Date()
    }

    $scope.recover = function () {

        const request = {
            ...queryService.normaliseQueryObject($scope.query),
            startTime: $scope.query.startTime,
            endTime: $scope.query.endTime,
        }
        searchService.post("betting/events/recoverAll" , request, "Betting markets recovery requested. This task will continue in background.", true).then(function (response) {
            console.log("Betting markets recovered")
        })
    }
});
